import script from "./RoleTimeView.vue?vue&type=script&setup=true&lang=ts"
export * from "./RoleTimeView.vue?vue&type=script&setup=true&lang=ts"

import "./RoleTimeView.vue?vue&type=style&index=0&id=a9d5cf5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9d5cf5a"]])

export default __exports__